// src/pages/AboutSlides.jsx
import React, { useState } from 'react';
import { Carousel } from 'react-bootstrap';
import '../pages/AboutSlides.css';
import image1 from '../images/Bull.jpeg';
import image2 from '../images/Cert.jpeg';
import image3 from '../images/Neighbours.jpg';
import image4 from '../images/final.jpeg';
import image5 from '../images/work.jpeg';
import image6 from '../images/linkroad.jpg';
import image7 from '../images/water.jpg';
import image8 from '../images/KaraAwards.jpg';

const AboutSlides = () => {
  const [showImages, setShowImages] = useState(false);

  const handleSlideChange = (index) => {
    // Show images on “OUR MISSION” (index 1) and “OUR ACHIEVEMENTS” (index 2)
    setShowImages(index === 1 || index === 2);
  };

  return (
    <Carousel indicators onSelect={handleSlideChange}>
      <Carousel.Item>
        <div className="slide-container history-slide">
          <h3 className="slide-title">OUR HISTORY</h3>
          <p>
            The Link Road Residents Association located in Kikuyu, Kenya, emerged in 2008/09 from the belief
            that united efforts foster community prosperity. Official registration in 2012 followed meticulous
            structuring led by visionary founders, including Jane W. Ngugi, David L. Karanja, and Allan Ngugi.
            The organization's formative phase prioritized Road Development Agenda (RDA), initiating crucial
            relationships with local and national government bodies, laying the foundation for sustained
            growth and development.
          </p>
          <div className="leadership-grid">
            {/* 2009–2017 */}
            <div className="leadership-block">
              <strong className="lead-heading">Leadership (2009 – 2017)</strong>
              <ul className="lead-list">
                <li>D. L. Karanja – Chairperson</li>
                <li>G. Karanja – Vice Chairperson</li>
                <li>Jane W. Ngugi – Secretary</li>
                <li>Peter Muchiri – Treasurer</li>
                <li>Allan Ngugi – Roads Committee Chairperson</li>
                <li>Ngige Mondo – Environment &amp; Water Committee Chairperson</li>
                <li>Major Stanley Kiama – Security Committee Chairperson</li>
                <li>Advisory Members (Legal)</li>
              </ul>
            </div>
            {/* 2017–2025 */}
            <div className="leadership-block">
              <strong className="lead-heading">Leadership (2018 – 2024)</strong>
              <ul className="lead-list">
                <li>Dan Mugo – Chairman</li>
                <li>Jane W. Ngugi – Secretary</li>
                <li>Peter Muchiri – Treasurer</li>
                <li>Ngige Mondo – Infrastructure Committee Chairperson</li>
                <li>Tony Gachie – Environment Committee Chairperson</li>
                <li>Peter Keni – Security Committee Chairperson</li>
                <li>Muigai Gitau – Membership Committee Chairperson (Interim)</li>
              </ul>
            </div>
            {/* Incoming 2025 + Zone Reps */}
            <div className="leadership-block">
              <strong className="lead-heading">Incumbent Leadership 2025</strong>
              <ul className="lead-list">
                <li>Jayne Ngugi – Chairperson</li>
                <li>Amelie Muthundo – Vice Chairperson/Secretary</li>
                <li>Wanjiru Ngige – Vice Secretary</li>
                <li>Shiela Karanja – Treasurer</li>
                <li>Mwaura Ngugi – Vice Treasurer</li>
                <li>Mark Kimani – Chairman (Security)</li>
                <li>Mercy Kiogora – Chairperson (Membership)</li>
                <li>David Gitau – Chairman (Infrastructure)</li>
                <li>Dennis Nyaga – Chairman (Environment)</li>
              </ul>
              <strong className="lead-heading">Zone Representatives</strong>
              <ul className="lead-list">
                <li>Zone A – John Irari</li>
                <li>Zone B – Wilson Wambugu</li>
                <li>Zone C – Tony Gachie</li>
              </ul>
            </div>
          </div>
        </div>
      </Carousel.Item>
      <Carousel.Item>
  <div className="slide-container mission-slide">
    <h3 className="slide-title">OUR VISION AND MISSION</h3>
    <p>
      <strong><em>Our Vision:</em></strong> <strong><em>'A Neighborhood Worth our Stay'.</em></strong>{' '}<br></br>
      <b><em>Our Mission:'Our Mission Centers on communal advancement, fostering a cohesive and empowered community.'</em></b>{' '}<br></br>
      Addressing security challenges, lobbying and maintaining essential infrastructures, ensuring
      reliable water and power supplies, and championing environmental standards remain our core
      pursuits. Embracing a non-partisan approach, we seek collaboration with like-minded entities
      to collectively enhance societal well-being.
    </p>
    {showImages && (
      <div className="images-container">
        <img className="mission-image" src={image5} alt="Mission 1" />
        <img className="mission-image" src={image6} alt="Mission 2" />
        <img className="mission-image" src={image7} alt="Mission 3" />
        <img className="mission-image" src={image4} alt="Mission 4" />
      </div>
    )}
  </div>
</Carousel.Item>

      <Carousel.Item>
        <div className="slide-container achievement-slide">
          <h3 className="slide-title">OUR ACHIEVEMENTS</h3>
          <p>
            The Association has garnered numerous accomplishments since its inception through extensive
            lobbying engagements with government, agencies and private sector. Significantly, achieving
            bitumen standards for Link Road E1507 and other infrastructural development underscores our
            dedication. Our influence secured street lighting installations, water supply enhancements,
            and oversaw existing infrastructural adherence. Acknowledged by Kenya Alliance of Residents
            Association (KARA) for promoting and safeguarding public interests, our commitment continues
            with ongoing initiatives—from preserving an environmentally friendly neighborhood and
            protecting public land and road reserves to bolstering security measures. We remain steadfast
            in our pursuit of our members welfare, a flourishing community, shaping a brighter and safer future for all residents.
          </p>
          {showImages && (
            <div className="images-container">
              <img className="achievement-image" src={image1} alt="Achievement 1" />
              <img className="achievement-image" src={image8} alt="Achievement 2" />
              <img className="achievement-image" src={image2} alt="Achievement 3" />
              <img className="achievement-image" src={image3} alt="Achievement 4" />
            </div>
          )}
        </div>
      </Carousel.Item>
    </Carousel>
  );
};

export default AboutSlides;
